import {
  AeroplaneIcon,
  AllInclusiveIcon,
  BeachPassIcon,
  CabanaIcon,
  DrinkServiceIcon,
  GymIcon,
  FoodServiceIcon,
  HotTubIcon,
  LazyRiverIcon,
  LockersIcon,
  PoolLoungeChairIcon,
  LuggageStorageIcon,
  PoolIcon,
  RestroomsIcon,
  RooftopPoolIcon,
  ShowersIcon,
  SpaPassIcon,
  TowelsIcon,
  WaterSlideIcon,
  AccessibleIcon,
  FoodDrinkIcon,
  DayRoomIcon,
  ParkingIcon,
  SaunaIcon,
  InfraredSaunaIcon,
  ColdPlungeIcon,
  LedRedLightTherapyIcon,
  SplashPadIcon,
  CruisePortShuttleIcon,
  DiamondIcon,
  FamilyFriendlyIcon,
  TrendyIcon,
  PartiesIcon,
  SereneIcon,
  StreamRoomIcon,
  ThermalPoolIcon,
  SaltRoomIcon,
} from '@resortpass/solar-icons';
import { FunctionComponent, SVGProps } from 'react';

export const AMENITY_ICON_MAPPING = {
  'airport-shuttle': AeroplaneIcon,
  'all-inclusive': AllInclusiveIcon,
  beach: BeachPassIcon,
  cabana: CabanaIcon,
  drink: DrinkServiceIcon,
  'fitness-center': GymIcon,
  food: FoodServiceIcon,
  hottub: HotTubIcon,
  lazyriver: LazyRiverIcon,
  lockers: LockersIcon,
  lounger: PoolLoungeChairIcon,
  'luggage-storage': LuggageStorageIcon,
  pool: PoolIcon,
  restrooms: RestroomsIcon,
  'rooftop-pool': RooftopPoolIcon,
  showers: ShowersIcon,
  spa: SpaPassIcon,
  towels: TowelsIcon,
  waterslide: WaterSlideIcon,
  wheelchair: AccessibleIcon,
  'food-service': FoodDrinkIcon,
  'drink-service': DrinkServiceIcon,
  'relaxation-lounge': DayRoomIcon,
  sauna: SaunaIcon,
  'infrared-sauna': InfraredSaunaIcon,
  'steam-room': StreamRoomIcon,
  'salt-room': SaltRoomIcon,
  'thermal-pool': ThermalPoolIcon,
  'cold-plunge': ColdPlungeIcon,
  'led-and-red-light-therapy': LedRedLightTherapyIcon,
  waterpark: WaterSlideIcon,
  'splash-pad': SplashPadIcon,
  'outdoor-pool': PoolIcon,
  'indoor-pool': PoolIcon,
  'infinity-pool': PoolIcon,
  'kiddie-pool': PoolIcon,
  'free-parking': ParkingIcon,
  'cruise-port-shuttle': CruisePortShuttleIcon,
};

const vibesIconMapping = {
  'Family-Friendly': FamilyFriendlyIcon,
  Luxe: DiamondIcon,
  Trendy: TrendyIcon,
  Party: PartiesIcon,
  Serene: SereneIcon,
};

export const getAmenityIcon = (
  id: string,
): FunctionComponent<SVGProps<SVGSVGElement>> | undefined => {
  if (id in AMENITY_ICON_MAPPING) {
    return AMENITY_ICON_MAPPING[id as keyof typeof AMENITY_ICON_MAPPING];
  }
  if (id in vibesIconMapping) {
    return vibesIconMapping[id as keyof typeof vibesIconMapping];
  }
  return undefined;
};
